import cx from 'classnames'
import { SidebarStep } from '@/common'
import { NavLink } from 'react-router-dom'

function SidebarNavigationStep({
  link,
  isComplete,
  title
}: {
  link: string
  isComplete: boolean
  title: string
}) {
  const onStepClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isComplete) {
      evt.preventDefault()
    }
  }
  return (
    <NavLink
      to={link}
      aria-disabled={!isComplete}
      onClick={onStepClick}
      className={cx({
        'pointer-events-none cursor-default': !isComplete
      })}
    >
      {({ isActive }) => (
        <SidebarStep isComplete={isComplete} isActive={isActive}>
          {title}
        </SidebarStep>
      )}
    </NavLink>
  )
}

export default function SidebarNavigationSteps({
  steps
}: {
  steps: {
    title: string
    isComplete: boolean
    link: string
    optional?: boolean
  }[]
}) {
  return (
    <ol>
      {steps.map(({ link, isComplete, title }, index) => (
        <li key={index}>
          <SidebarNavigationStep link={link} isComplete={isComplete} title={title} />
        </li>
      ))}
    </ol>
  )
}
